
const digest = '18579e0752c9bb33172f35b0fa164081f1002957d00f6d8bc93e1f341cfcd62a';
const css = `._embedInline_1gdfa_1 {
  display: inline-block;
  vertical-align: middle;
  margin: 0.5em;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"embedInline":"_embedInline_1gdfa_1"};
export { css, digest };
  